<div [ngSwitch]="key">
  <p-toast *ngSwitchDefault [key]="key" [position]="position" [styleClass]="styleClass"></p-toast>
  <p-toast
    *ngSwitchCase="'toast-layout-viewDetail'"
    [key]="key"
    [position]="position"
    [styleClass]="styleClass"
    [preventOpenDuplicates]="true"
  >
    <ng-template let-message pTemplate="message">
      <span class="p-toast-icon pi"></span>
      <div class="p-toast-message-text">
        <div class="p-toast-summary">{{ message.summary }}</div>
        <div class="p-toast-detail">
          <ng-container *ngIf="message.data; else blockMessage">
            <a (click)="onClick(message.data)">{{ message.detail }}</a>
          </ng-container>
          <ng-template #blockMessage> <div innerHtml="{{ message.detail }}"></div> </ng-template>
        </div>
      </div>
    </ng-template>
  </p-toast>
  <p-toast *ngSwitchCase="'toast-layout-errors'" [key]="key" [position]="position" [styleClass]="styleClass" [preventOpenDuplicates]="true">
    <ng-template let-message pTemplate="message">
      <span class="p-toast-icon pi mu-toast-icon"></span>
      <div class="p-toast-message-text-content">
        <div class="p-toast-summary">{{ message.summary }}</div>
        <div class="p-toast-detail">
          <ng-container *ngIf="message.data === 'raw-html'; else chatMessage">
            <div innerHtml="{{ message.detail }}"></div>
          </ng-container>
          <ng-template #chatMessage> {{ message.detail }} <a class="mu-toast-a" (click)="onClick(message.data)">chat.</a> </ng-template>
        </div>
      </div>
    </ng-template>
  </p-toast>
  <p-toast
    *ngSwitchCase="'toast-layout-new-users'"
    [key]="key"
    [position]="position"
    [styleClass]="styleClass"
    [preventOpenDuplicates]="false"
  >
    <ng-template let-message pTemplate="message">
      <span class="p-toast-icon pi mu-toast-icon"></span>
      <div class="p-toast-message-text-content">
        <div class="p-toast-summary">{{ message.summary }}</div>
        <div class="p-toast-detail">
          {{ message.detail }} chat
          {{ 'toast.common.success.support' | translate }}
          <a class="mu-toast-a" (click)="onClick(message.data.back)"> {{ 'toast.common.success.here' | translate }} </a>
        </div>
      </div>
    </ng-template>
  </p-toast>
  <p-toast
    *ngSwitchCase="'toast-layout-onlyDetail'"
    [key]="key"
    [position]="position"
    [styleClass]="styleClass"
    [preventOpenDuplicates]="true"
  >
    <ng-template let-message pTemplate="message">
      <span class="p-toast-icon pi mu-toast-icon"></span>
      <div class="p-toast-message-text-content-no-margin">
        <div class="p-toast-detail">
          <div innerHtml="{{ message.detail }}"></div>
        </div>
      </div>
    </ng-template>
  </p-toast>
</div>
